import {AxiosRequestConfig} from 'axios'
import RequestBase from '../../../api/RequestBase'
import {
  AccountBranchesResponse,
  OrganizationAccountsResponse,
  OrganizationManagersResponse,
  ShipmentTrendDataResponse,
  ShipmentsMapDataResponse,
  TotalShipmentsResponse,
  TotalSpendResponse,
} from './_types'

const URL = '/company/analytics'
const ACCOUNT_BASE_URL = '/company/accounts'
const MANAGER_BASE_URL = '/company/managers'

const getTotalShipments = async (
  payload?: any,
  config?: AxiosRequestConfig | undefined
): Promise<TotalShipmentsResponse> => {
  return RequestBase.post(`${URL}/total-shipments`, payload, config)
}

const getTotalSpend = async (
  payload?: any,
  config?: AxiosRequestConfig | undefined
): Promise<TotalSpendResponse> => {
  return RequestBase.post(`${URL}/total-spend`, payload, config)
}

const getShipmentsTrendData = async (
  payload?: any,
  config?: AxiosRequestConfig | undefined
): Promise<ShipmentTrendDataResponse> => {
  return RequestBase.post(`${URL}/shipments-trend`, payload, config)
}

const getAccountBranches = async (
  config?: AxiosRequestConfig | undefined
): Promise<AccountBranchesResponse> => {
  return RequestBase.get(`${ACCOUNT_BASE_URL}/branches`, config)
}

const getAccounts = async (
  payload?: Record<string, unknown>,
  config?: AxiosRequestConfig | undefined
): Promise<OrganizationAccountsResponse> => {
  return RequestBase.post(`${ACCOUNT_BASE_URL}/`, payload, config)
}

const getManagersAssignable = async (
  config?: AxiosRequestConfig | undefined
): Promise<OrganizationManagersResponse> => {
  return RequestBase.get(`${MANAGER_BASE_URL}/assignable`, config)
}

const assignManager = async (
  branch: string,
  payload?: any,
  config?: AxiosRequestConfig | undefined
): Promise<OrganizationManagersResponse> => {
  return RequestBase.patch(`${MANAGER_BASE_URL}/${branch}`, payload, config)
}

const getShipmentsMapData = async (
  payload?: any,
  config?: AxiosRequestConfig | undefined
): Promise<ShipmentsMapDataResponse> => {
  return RequestBase.post(`${URL}/shipments-map`, payload, config)
}

const OrganizationService = {
  getTotalShipments,
  getTotalSpend,
  getShipmentsTrendData,
  getShipmentsMapData,
  getAccountBranches,
  getAccounts,
  getManagersAssignable,
  assignManager,
}

export default OrganizationService
